<template>
  <ul class="mdl-list">
    <li class="mdl-list__title">{{ data.fecha || '?' }}</li>
    <li>
      <ul class="mdl-list">
        <li v-for="(auditoria, index) in data.auditorias" @click="showReport" :data-index="index"
          :class="['audit', 'mdl-list__item', 'mdl-list__item--two-line',
                  auditoria.statusId === 4 ? 'bg-green-light' : '']">
          <span class="mdl-list__item-primary-content">
            <!-- <i class="material-icons mdl-list__item-avatar"
              :style="{ backgroundImage: 'url('+auditoria.imagen+')'}"></i> -->
            <span class="mdl-list__item-title">{{ auditoria.inmueble }}</span>
            <span class="mdl-list__item-sub-title">{{ auditoria.empresa }}</span>
          </span>
          <span class="mdl-list__item-secondary-content">
            <span class="mdl-list__item-sub-title">{{ auditoria.incidencias }}</span>
            <span class="mdl-list__item-secondary-info">Incidencias</span>
          </span>
          <span class="mdl-list__item-secondary-content">
            <span :class="['mdl-list__item-sub-title',
              auditoria.promedio >= auditoria.aceptable ? 'color-green-light' :
              ( auditoria.promedio > auditoria.inaceptable ? 'color-yellow' : 'color-red' )]">{{ auditoria.promedio }}</span>
            <span class="mdl-list__item-secondary-info">Puntos</span>
          </span>
          <span class="mdl-list__item-secondary-content">
            <span :class="['mdl-list__item-secondary-info',
              auditoria.statusId === 4 ? 'color-green-light' :
              auditoria.statusId === 2 ? 'color-yellow' : '']">{{ auditoria.statusNombre }}</span>
          </span>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
export default {
  props: ['data'],
  data () {
    return {
      actionbar: {}
    }
  },
  methods: {
    showReport (event) {
      let auditorias = this.data.auditorias,
          index = event.currentTarget.dataset.index,
          auditoria = auditorias[index]

      if (auditoria.mantenimiento) {
        if (typeof auditoria.mantenimiento === 'string') {
          auditoria.mantenimiento = JSON.parse(auditoria.mantenimiento)
        }
      } else {
        auditoria.mantenimiento = {}
      }

      this.$emit('showReport', auditoria)
    }
  },
  mounted () {
    this.$actionbar.init(this.actionbar)
  }
}
</script>

<style lang="css" scoped>
  .audit {
    cursor: pointer;
  }

  .mdl-list .mdl-list__title {
    /*margin-left: 1rem;*/
  }

  .mdl-list .mdl-list__item[main-item] {
    height: 0;
    /*border-bottom: 2px solid #e6e5e5;*/
  }

  .mdl-list .mdl-list__item {
    background-color: #fff;
  }

  .mdl-list .mdl-list__item-primary-content {
    width: 50%
  }

  .mdl-list .mdl-list__item-primary-content .mdl-list__item-title {
    display: block;
    /*margin-top: 6px;*/
    font-weight: bolder;
    font-size: 1rem;
  }

  .mdl-list .mdl-list__item-secondary-content {
    width: 12.50%;
  }

  .mdl-list .mdl-list__item-secondary-content .mdl-list__item-sub-title {
    display: block;
    width: 100%;
    font-size: 1.25rem;
    font-weight: bolder;
    line-height: 1.5;
    text-align: center;
  }

  .mdl-list .mdl-list__item-secondary-content .mdl-list__item-secondary-info {
    display: block;
    width: 100%;
    font-weight: bolder;
    font-size: 0.75rem;
    text-align: center;
    text-transform: uppercase;
  }
</style>


// WEBPACK FOOTER //
// List.vue?cbbb1314